"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDialog = AlertDialog;
exports.AlertDialogTrigger = AlertDialogTrigger;
exports.AlertDialogContent = AlertDialogContent;
exports.AlertDialogHeader = AlertDialogHeader;
exports.AlertDialogFooter = AlertDialogFooter;
exports.AlertDialogTitle = AlertDialogTitle;
exports.AlertDialogDescription = AlertDialogDescription;
exports.AlertDialogAction = AlertDialogAction;
exports.AlertDialogCancel = AlertDialogCancel;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const cn_1 = require("cn");
const radix_ui_1 = require("radix-ui");
const button_1 = require("./button");
function AlertDialog({ ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Root, { "data-slot": "alert-dialog", ...props });
}
function AlertDialogTrigger({ ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Trigger, { "data-slot": "alert-dialog-trigger", ...props });
}
function AlertDialogPortal({ ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Portal, { "data-slot": "alert-dialog-portal", ...props });
}
function AlertDialogOverlay({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Overlay, { "data-slot": "alert-dialog-overlay", className: (0, cn_1.cn)('fixed inset-0 z-50 bg-black/45 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0', className), ...props }));
}
function AlertDialogContent({ className, ...props }) {
    return ((0, jsx_runtime_1.jsxs)(AlertDialogPortal, { children: [(0, jsx_runtime_1.jsx)(AlertDialogOverlay, {}), (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Content, { "data-slot": "alert-dialog-content", className: (0, cn_1.cn)('fixed top-[50%] left-[50%] z-50 grid w-full max-w-[460px] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-xl border bg-card p-6 shadow-lg duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95', className), ...props })] }));
}
function AlertDialogHeader({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "alert-dialog-header", className: (0, cn_1.cn)('flex flex-col gap-2', className), ...props });
}
function AlertDialogFooter({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "alert-dialog-footer", className: (0, cn_1.cn)('flex justify-end gap-2', className), ...props });
}
function AlertDialogTitle({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Title, { "data-slot": "alert-dialog-title", className: (0, cn_1.cn)('text-base font-medium', className), ...props });
}
function AlertDialogDescription({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Description, { "data-slot": "alert-dialog-description", className: (0, cn_1.cn)('text-[12.5px] leading-relaxed text-muted-foreground', className), ...props }));
}
function AlertDialogAction({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Action, { className: (0, cn_1.cn)((0, button_1.buttonVariants)(), className), ...props });
}
function AlertDialogCancel({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)(radix_ui_1.AlertDialog.Cancel, { className: (0, cn_1.cn)((0, button_1.buttonVariants)({ variant: 'outline' }), className), ...props });
}
